// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1uLgd","clinicsSelect":"TableHeading_clinicsSelect__1Bbd3"};